// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__1AbpY","logoTextSemicolon":"Logo_logoTextSemicolon__1c1CB"};